import { useField, useFormikContext } from 'formik';

import { EnumComboBox, type EnumComboBoxProps } from '../../enums/EnumComboBox';

interface FormikEnumComboBoxProps extends Omit<EnumComboBoxProps, 'value' | 'onChange'> {
    name: string;
}

export function FormikEnumComboBox(props: FormikEnumComboBoxProps) {
    const [field, meta, helpers] = useField<string>(props.name);
    const { validateOnChange } = useFormikContext();

    const onChange = (option: string) => {
        helpers.setValue(option);
        if (!validateOnChange && meta.error) {
            helpers.setError(undefined);
        }
    };

    return (
        <EnumComboBox
            {...props}
            {...field}
            onChange={onChange}
            enumType={props.enumType}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
}
